import { render, staticRenderFns } from "./DetailAndroidAccountForm.vue?vue&type=template&id=38494946&scoped=true&"
import script from "./DetailAndroidAccountForm.vue?vue&type=script&lang=ts&"
export * from "./DetailAndroidAccountForm.vue?vue&type=script&lang=ts&"
import style0 from "./DetailAndroidAccountForm.vue?vue&type=style&index=0&id=38494946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38494946",
  null
  
)

export default component.exports